import { client } from '@api/client';

import { IApiDocumentationParams } from '@interfaces/platform/dto/reportDTO';

export const generateApiDocumentation = (params: IApiDocumentationParams): Promise<void> => {
	return client.post(`/rest-api-docs`, params);
};
